module.exports = __webpack_public_path__ + "static/Search-animation-v02-9aec1ceae2871bc815facc62ca015460.gif";